
export const makeData =  [
    { label: "Acura", value: "Acura", query: "make" },
    { label: "Alfa Romeo", value: "Alfa Romeo", query: "make" },
    { label: "Audi", value: "Audi", query: "make" },
    { label: "BMW", value: "BMW", query: "make" },
    { label: "Cadillac", value: "Cadillac", query: "make" },
    { label: "Chevrolet", value: "Chevrolet", query: "make" },
    { label: "Chrysler", value: "Chrysler", query: "make" },
    { label: "Dodge", value: "Dodge", query: "make" },
    { label: "Fiat", value: "Fiat", query: "make" },
    { label: "Ford", value: "Ford", query: "make" },
    { label: "GMC", value: "GMC", query: "make" },
    { label: "Honda", value: "Honda", query: "make" },
    { label: "Hyundai", value: "Hyundai", query: "make" },
    { label: "Infiniti", value: "Infiniti", query: "make" },
    { label: "Jaguar", value: "Jaguar", query: "make" },
    { label: "Jeep", value: "Jeep", query: "make" },
    { label: "Kia", value: "Kia", query: "make" },
    { label: "Land Rover", value: "Land Rover", query: "make" },
    { label: "Lexus", value: "Lexus", query: "make" },
    { label: "Lincoln", value: "Lincoln", query: "make" },
    { label: "Maserati", value: "Maserati", query: "make" },
    { label: "Mazda", value: "Mazda", query: "make" },
    { label: "Mercedes-Benz", value: "Mercedes-Benz", query: "make" },
    { label: "Mitsubishi", value: "Mitsubishi", query: "make" },
    { label: "Nissan", value: "Nissan", query: "make" },
    { label: "Porsche", value: "Porsche", query: "make" },
    { label: "Ram", value: "Ram", query: "make" },
    { label: "Subaru", value: "Subaru", query: "make" },
    { label: "Tesla", value: "Tesla", query: "make" },
    { label: "Toyota", value: "Toyota", query: "make" },
    { label: "Volkswagen", value: "Volkswagen", query: "make" },
    { label: "Volvo", value: "Volvo", query: "make" },
 
];
